import { useEffect, useState } from 'react';
import './styles/App.css';
import './styles/styles.css';
import './styles/Components.css';
import { AuthContext } from './context/authContext';
import Main from './components/fragments/main';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setLoading] = useState(true);

  useEffect(()=>{
    if (localStorage.getItem('accessToken')){
      if (localStorage.getItem('accessToken')!==""){
        setIsAuthenticated(true);
      }
      else {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
      }
    }
    setLoading(false);
  },[isAuthenticated]);

        let date = new Date();
        // let offset = date.getTimezoneOffset();
        let offset = 0;
        let absOffset = Math.abs(offset)
        let offHours = parseInt((absOffset)/60);
        let offMinutes = absOffset-(60*offHours);
        if (Math.abs(offHours)<10) offHours = "0"+offHours;
        if (Math.abs(offMinutes)<10) offMinutes = "0"+offMinutes;
        let outString = offHours+":"+offMinutes;

        if (offset>0) outString = ":00-"+outString;
        else outString = ":00+"+outString;
        console.log(outString);

  return (
    <AuthContext.Provider value={{
      isAuthenticated,
      setIsAuthenticated,
      isLoading
    }}>
      <Main/>
    </AuthContext.Provider>
  );
}

export default App;